import { AgeGroup } from './age-group.model';
import { RangeFilter } from './custom-filter-range.model';

export const allSpendingGroupsLabel: string = 'All spending groups';

export class SpendingGroup extends AgeGroup {
  constructor(
    public name?: string,
    public greaterThan?: number,
    public lessThan?: number,
    public id?: number,
    public subgroups: SpendingGroup[] = [],
    public disabled: boolean = false,
    public opened: boolean = false,
    public type = 'Spending'
  ) {
    super(greaterThan, lessThan, name, disabled, id);
  }

  public static from(rangeFilter: RangeFilter) {
    return new SpendingGroup(
      rangeFilter.name,
      rangeFilter.greaterThan,
      rangeFilter.lessThan,
      rangeFilter.id
    );
  }

  public displayValue(): string {
    if (this.compactDisplayValue() === allSpendingGroupsLabel) {
      return this.compactDisplayValue();
    }

    return `${this.compactDisplayValue()} ${this.name}`;
  }

  public compactDisplayValue(): string {
    if (this.greaterThan !== undefined && this.lessThan != undefined) {
      return `$${this.greaterThan}-${this.lessThan}`;
    }

    if (this.greaterThan !== undefined) {
      return `$>${this.greaterThan}`;
    }

    if (this.lessThan !== undefined) {
      return `$<${this.lessThan}`;
    }

    return allSpendingGroupsLabel;
  }
}
